import { gql } from "@apollo/client";

import { getClient } from "lib/apolloClient";

const REMOVE_REPLENISHMENT_PRODUCT = gql`
  mutation removeMyReplenishmentProduct($sku: String!) {
    removeMyReplenishmentProduct(sku: $sku)
  }
`;

export const removeMyReplenishmentProduct = async (sku: string) => {
  const client = getClient();
  await client.mutate({
    mutation: REMOVE_REPLENISHMENT_PRODUCT,
    variables: { sku }
  });
};
